import { Html } from "@glidejs/glide/components/html";

class FieldReset {
    static init() {
        const components: NodeListOf<HTMLElement> = document.querySelectorAll(".js-reset-fld");

        if (components.length) {
            components.forEach((item: HTMLElement, index: number) => {
                const itemTargetTextbox: HTMLInputElement = document.getElementById(item.dataset.target) as HTMLInputElement;

                if (itemTargetTextbox) {
                    this.toggleResetBtn(itemTargetTextbox);

                    itemTargetTextbox.addEventListener("keyup", (e: Event) => {                      
                        this.toggleResetBtn(e.currentTarget as HTMLInputElement);
                    });
                }

                item.addEventListener("click", (e: Event) => {
                    if (e) {
                        const currentTarget = e.currentTarget as HTMLElement;
                        const targetTextbox: HTMLInputElement = document.getElementById(currentTarget.dataset.target) as HTMLInputElement;

                        if (targetTextbox) {
                            targetTextbox.value = "";
                            this.toggleResetBtn(targetTextbox);
                            currentTarget.classList.add("hide");
                        }
                    }
                });
            });
        }
    }

    private static toggleResetBtn(textbox: HTMLInputElement): void {
        const resetBtn: HTMLSpanElement = document.querySelector(`[data-target="${textbox.id}"]`);

        if (textbox.value === '') {
            resetBtn.classList.add("hide");
        }
        else {
            resetBtn.classList.remove("hide");
        }
    }
}

export default FieldReset;